import { trigger, transition, query, style, animate } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Camera } from '@classes/camera/camera';
import { faCar, faInfoCircle, faSearch } from '@fortawesome/free-solid-svg-icons';
import { CamerasService } from '@services/cameras/cameras.service';
import { DashbordService } from '@services/dashboard/dashbord.service';
import { ExportExcelFileService } from '@services/export-excel-file/export-excel-file.service';
import { RolesService } from '@services/roles/roles.service';
import { SmartparkingCameraInfosLastSyncComponent } from '../smartparking-camera-infos-last-sync/smartparking-camera-infos-last-sync.component';

@Component({
  selector: 'app-smartparking-dashboard',
  templateUrl: './smartparking-dashboard.component.html',
  styleUrls: ['./smartparking-dashboard.component.scss'],
  animations: [
    trigger('show', [
      transition(':enter', [
        query('.divChart', [
          style({ opacity: 0, transform: 'translate(200px)' }),
          animate('.17s', style({ opacity: 1, transform: 'none' })),
        ], { optional: true })
      ]),
    ]),
  ]
})
export class SmartparkingDashboardComponent implements OnInit {

  faInfoCircle = faInfoCircle;
  faSearch = faSearch;
  faCar = faCar;

  displayedColumns: string[] = ['name', 'ip', 'port', 'syncTime', 'id', 'numbCars', 'lastSync'];
  dataSource: MatTableDataSource<Camera>;

  length: number;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  camera: Camera[];
  tab = 'occupancy-rate';
  // tab = 'car-suction-cup';


  constructor(
    private cameraService: CamerasService,
    private dialog: MatDialog,
    private roleService: RolesService
  ) { }

  ngOnInit(): void {
    this.getCameras();
    this.roleService.getRoleUserApp();
  }

  applyFilter(filterValue): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openDialogInfoCamera(infos: Camera): void {
    const dialogRef = this.dialog.open(SmartparkingCameraInfosLastSyncComponent, {
      data: { lastSync: infos }
    });
  }

  setTab(tab: string): void {
    this.tab = tab;
  }


  private getCameras(): void {
    this.cameraService.getCameras().subscribe(res => {
      this.camera = res;
      this.dataSource = new MatTableDataSource<Camera>(res);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;

      const date = new Date();
      date.setDate(date.getDate() - 7);

    });
  }

}
